'use strict';

var _utils = require('./internal/utils');

var _io = require('./internal/io');

var _proc = require('./internal/proc');

var _testUtils = require('./internal/testUtils');

var _monitorActions = require('./internal/monitorActions');

var monitorActions = _interopRequireWildcard(_monitorActions);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

module.exports = {
  TASK: _utils.TASK,
  noop: _utils.noop,
  is: _utils.is,
  asEffect: _io.asEffect,
  deferred: _utils.deferred,
  arrayOfDeffered: _utils.arrayOfDeffered,
  asap: _utils.asap,
  CANCEL: _proc.CANCEL,
  RACE_AUTO_CANCEL: _proc.RACE_AUTO_CANCEL,
  PARALLEL_AUTO_CANCEL: _proc.PARALLEL_AUTO_CANCEL,
  MANUAL_CANCEL: _proc.MANUAL_CANCEL,
  createMockTask: _testUtils.createMockTask,
  monitorActions: monitorActions
};